<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h14">Remerciements</h1>
<p class="p0"><img alt="img2.png" height="132" src="images/img2.png" width="441"/></p>
<p class="p7"> </p>
<p class="p7">Merci comme toujours à mon super groupe de soutien – Alex, Dottie et Chudney. Un merci tout particulier à Dolorianne qui m’a sauvée sur celui-là.</p>
<p class="p7"> </p>
<p class="p7">Je dois également remercier le Centre de Soutien de Vol d’Identité Canadien, et particulièrement Heather, qui a été d’une aide très précieuse et a répondu à toutes mes questions. Si quoi que ce soit devait être incorrect, c’est entièrement ma faute. </p>
<p class="p8"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?c0b8a7a0